import { enUS, ru } from "date-fns/locale";

export const DATE_FORMATS = [
  {
    id: "ru_full",
    label: "Day.Month.Year",
    format: "dd.MM.yyyy",
  },
  {
    id: "iso_date",
    label: "ISO / Database",
    format: "yyyy-MM-dd",
  },
  {
    id: "en_text",
    label: "Full Text Date",
    format: "d MMMM yyyy",
  },
  {
    id: "ru_short",
    label: "Short (2-digit year)",
    format: "dd.MM.yy",
  },
  {
    id: "us_date",
    label: "US Format",
    format: "MM/dd/yyyy",
  },
] as const;

export const DATE_FNS_LOCALES = {
  ru: ru,
  en: enUS,
};

export const EMPTY_LIST = [1, 2, 3, 4, 5];


export const EMPTY_TABLE_LIST = [1, 2, 3, 4, 5];
